<template>
  <div class="survey-radio-buttons" role="radiogroup" :aria-label="ariaLabel">
    <b-button
      v-for="opt in options"
      :key="opt"
      type="button"
      size="sm"
      class="survey-radio-buttons__btn"
      :style="{ minWidth: minWidth }"
      :variant="value === opt ? 'secondary' : 'outline-secondary'"
      :pressed="value === opt"
      role="radio"
      :aria-checked="value === opt ? 'true' : 'false'"
      @click="$emit('input', opt)"
      >{{ opt }}</b-button
    >
  </div>
</template>

<script>
export default {
  name: "SurveyRadioButtonGroup",
  props: {
    value: { type: [String, Number, Boolean], default: null },
    options: { type: Array, required: true },
    minWidth: { type: String, default: "110px" },
    ariaLabel: { type: String, default: null },
  },
};
</script>

<style lang="scss" scoped>
.survey-radio-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.survey-radio-buttons__btn {
  // larghezza naturale del testo con min-width, niente stretch
  flex: 0 0 auto;
  border-radius: 999px;
  padding-left: 1rem;
  padding-right: 1rem;
  white-space: normal;
}
</style>
